import { DialogCargaMovimientoItem } from "./movimiento";

export class Contrato {
    constructor(
        public readonly Id: number,
        public readonly Codigo: string | null,
        public readonly TipoContrato: number,
        public readonly FechaInicio: Date,
        public readonly FechaFin: Date | null,
        public readonly ComunidadId: number,
        public readonly AlicuotaIvaId: number | null,
        public readonly AlicuotaIva: string | null,
        public readonly MontoAlicuotaIva: number,
        public readonly MonedaId: number,
        public readonly MontoBase: number | null,
        public readonly Monto: number | null,
        public readonly Observaciones: string | null,
        public readonly Activo: boolean,
        public Adjuntos: ContratoAdjunto[],
        public UnidadesFuncionales: ContratoUnidadFuncional[],
        public Personas: ContratoPersona[]
    ) {}
}

export class SearchContratoRequest {
    constructor(
      public readonly PageSize: number | null,
      public readonly PageNumber: number | null,
      public readonly OrderAscending: boolean | null,
      public readonly OrderFieldName: string | null,
      public readonly Codigo: string | null,
      public readonly Tipo: number | null,
      public readonly FechaInicioDesde: number | null,
      public readonly FechaInicioHasta: number | null,
      public readonly MonedaId: number | null,
      public readonly ComunidadId: number | null,
      public readonly UnidadFuncionalId: number | null,
      public readonly UnidadFuncionalCodigo: string | null,
      public readonly PersonaNroDocumento: string | null,
      public readonly PersonaMovil: string | null,
      public readonly PersonaMail: string | null,
      public readonly VerSoloActivos: boolean | null
    ) {}
}

export class SaveContratoDto {
    constructor(
        public Id: number,
        public Codigo: string | null,
        public TipoContrato: number,
        public FechaInicio: Date,
        public FechaFin: Date | null,
        public ComunidadId: number,
        public AlicuotaIvaId: number | null,
        public MonedaId: number,
        public Monto: number | null,
        public Observaciones: string | null,
        public Activo: boolean | null,
        public UnidadesFuncionales: number[],
        public Personas: ContratoPersona[],
        public readonly Deudas: DialogCargaMovimientoItem[]
    ) {}
}

export class SearchContratoResponse {
    constructor(
        public readonly count: number,
        public readonly result: Contrato[]
    ) {}
}

export class TipoContrato {
    constructor(
      public readonly Id: number,
      public readonly Nombre: string
    ) {}
}

export class UploadContratoAttachResponseDto {
    constructor (
        public readonly Archivos: ContratoAdjunto[]
    ) {}
}

export class ContratoAdjunto {
    constructor (
        public readonly Id: number,
        public readonly NombreDocumento: string | null,
        public readonly UrlDocumento: string | null,
        public readonly ContratoId: number
    ) {}
}

export class ContratoUnidadFuncional {
    constructor (
        public readonly Id: number,
        public readonly UnidadFuncionalId: number,
        public readonly UnidadFuncionalCodigo: string | null,
        public readonly UnidadFuncionalNumero: number,
        public readonly UnidadFuncionalTipoUnidad: string | null,
        public readonly UnidadFuncionalCantidadAmbientes: number | null,
        public readonly UnidadFuncionalNroPiso: number | null,
        public readonly UnidadFuncionalComunidad: string | null,
        public readonly UnidadFuncionalConsorcio: string | null,
        public readonly ContratoId: number,
        public Importe: number
    ) {}
}

export class ContratoPersona {
    constructor (
        public readonly Id: number,
        public readonly PersonaId: number,
        public readonly PersonaNombre: string | null,
        public readonly PersonaApellido: string | null,
        public readonly PersonaTipoDocumento: string | null,
        public readonly PersonaNroDocumento: string | null,
        public readonly PersonaCuit: number | null,
        public readonly PersonaMailContacto: string | null,
        public readonly PersonaMovilContacto: string | null,
        public readonly ContratoId: number,
        public Porcentaje: number,
        public readonly PuedeEnviarInvitacion: boolean
    ) {}
}

export class SaveContratoMovimientoDto {
    constructor(
        public readonly ContratoId: number,
        public readonly Deudas: DialogCargaMovimientoItem[]
    ) {}
}